(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/ticketgames/ticket-scratch/assets/javascripts/components/top-bar/top-bar-menu/top-bar-menu.js') >= 0) return;  svs.modules.push('/components/ticketgames/ticket-scratch/assets/javascripts/components/top-bar/top-bar-menu/top-bar-menu.js');
"use strict";

const {
  Fragment,
  useState,
  useEffect,
  useRef,
  useCallback
} = React;
setGlobal('svs.ticketgames.ticketScratch.components.topBar.topBarMenu.TopBarMenu', _ref => {
  let {
    demo,
    onClose,
    spelguidesExists,
    setActiveTab,
    spelguides,
    ticketDispatcher,
    gameHasSound,
    gameInfoOpen,
    toggleGameInfo,
    toggleOverlay
  } = _ref;
  const TopBarMenuItem = svs.ticketgames.ticketScratch.components.topBar.topBarMenu.TopBarMenuItem;
  const TopBarTabs = svs.ticketgames.ticketScratch.components.topBar.topBarMenu.TopBarTabs;
  const Icon = svs.ui.ReactIcon;
  const [isSoundActive, setisSoundActive] = useState(false);
  const [showGameInfo, setShowGameInfo] = useState(true);
  const gameInfoRef = useRef(null);
  useEffect(() => {
    const events = [{
      eventName: 'SOUND_STATUS',
      handler: setisSoundActive
    }];
    ticketDispatcher.addListeners(events, 'topbar-menu');
    return () => {
      ticketDispatcher.removeListeners('topbar-menu');
    };
  }, [ticketDispatcher]);
  const showOverlay = useCallback(show => {
    toggleOverlay(show);
    setShowGameInfo(show);
  }, [toggleOverlay]);
  useEffect(() => {
    gameInfoOpen && showOverlay(true);
    const anim = gsap.to(gameInfoRef.current, {
      x: gameInfoOpen ? '0%' : '100%',
      duration: gameInfoOpen ? 0.3 : 0.5,
      onComplete: () => {
        gameInfoRef.current.style.visibility = 'visible';

        !gameInfoOpen && showOverlay(false);
      }
    });
    return () => anim.kill();
  }, [gameInfoOpen, showOverlay]);
  const dialogTexts = {
    close: {
      icon: 'help-2',
      title: 'Vill du avsluta spelet?',
      message: {
        text: demo ? ' ' : 'Du hittar dina köpta lotter i Mina spel'
      },
      actions: {
        cancel: {
          title: 'AVBRYT'
        },
        action: {
          title: 'AVSLUTA SPEL',
          callback: e => {
            e.preventDefault();
            onClose(e);
          }
        }
      }
    },
    selfTest: {
      icon: 'self-test',
      title: 'Vill du göra ett självtest?',
      message: {
        text: "Du l\xE4mnar spelet om du g\xF6r ett sj\xE4lvtest. ".concat(demo ? '' : 'Du hittar köpta lotter i Mina spel.')
      },
      actions: {
        cancel: {
          title: 'AVBRYT'
        },
        action: {
          title: 'GÖR SJÄLVTEST',
          callback: e => {
            e.preventDefault();
            if (svs.core.userSession.hasRole(svs.core.userSession.roles.PLAYER)) {
              window.location.href = svs.core.urlMapping.get('gamingResponsibilityHabits');
            } else {
              window.location.href = svs.core.urlMapping.get('gamingResponsibilitySelfTest');
            }
          }
        }
      }
    }
  };
  const showDialog = _ref2 => {
    let {
      type
    } = _ref2;
    const dialogSettings = dialogTexts[type];
    const dialog = new svs.components.dialog.Confirm({
      branding: svs.components.dialog.branding.TUR,
      icon: dialogSettings.icon,
      area: svs.components.dialog.area.POPUP,
      title: dialogSettings.title,
      message: [{
        type: svs.components.dialog.message.TEXT,
        text: dialogSettings.message.text
      }],
      actions: [{
        title: dialogSettings.actions.cancel.title,
        callback: () => {
          dialog.close();
        }
      }, {
        title: dialogSettings.actions.action.title,
        callback: e => {
          dialogSettings.actions.action.callback(e);
          dialog.close();
        }
      }]
    });
    svs.components.dialog.api.add(dialog);
  };
  const handleSetSound = () => {
    svs.ticketgames.falconBridge.falcon.instance.notifierProxy.notifySoundStatus(!isSoundActive);
  };
  return React.createElement(Fragment, null, React.createElement("div", {
    className: "bg-navy padding-1 ts-top-bar relative"
  }, React.createElement("div", {
    className: "ts-top-bar-left"
  }, React.createElement(TopBarMenuItem, {
    className: "fc-white ts-top-bar-menu-item margin-right-2 u-text-decoration-underline js-pause24-trigger",
    tabbable: !gameInfoOpen
  }, "Spelpaus24"), React.createElement(TopBarMenuItem, {
    className: "fc-white ts-top-bar-menu-item u-text-decoration-underline",
    handleOnClick: () => showDialog({
      type: 'selfTest'
    }),
    tabbable: !gameInfoOpen
  }, "Sj\xE4lvtest")), React.createElement("div", {
    className: "ts-top-bar-right"
  }, gameHasSound && React.createElement(TopBarMenuItem, {
    ariaLabel: isSoundActive ? 'Slå av ljud' : 'Slå på ljud',
    className: "margin-right-2",
    handleOnClick: handleSetSound,
    tabbable: !gameInfoOpen
  }, React.createElement(Icon, {
    color: "fc-white",
    icon: isSoundActive ? 'sound-on' : 'sound-off'
  })), spelguidesExists && React.createElement(TopBarMenuItem, {
    ariaLabel: "Spelinformation",
    className: "margin-right-2",
    handleOnClick: () => toggleGameInfo(true),
    tabbable: !gameInfoOpen
  }, React.createElement(Icon, {
    color: "fc-white",
    icon: "information"
  })), React.createElement(TopBarMenuItem, {
    ariaLabel: "St\xE4ng",
    handleOnClick: () => showDialog({
      type: 'close'
    }),
    tabbable: !gameInfoOpen
  }, React.createElement(Icon, {
    color: "fc-white",
    icon: "close"
  })))), React.createElement("div", {
    className: "bg-navy ts-top-bar-game-info absolute",
    ref: gameInfoRef,
    style: {
      visibility: 'hidden'
    }
  }, React.createElement("div", {
    className: "ts-top-bar-game-info-left"
  }, React.createElement("div", {
    className: "padding-1"
  }, showGameInfo && React.createElement(TopBarMenuItem, {
    ariaLabel: "Tillbaka",
    className: "margin-right-1",
    handleOnClick: () => toggleGameInfo(false),
    tabbable: gameInfoOpen
  }, React.createElement(Icon, {
    color: "fc-white",
    icon: "menu-left"
  }))), spelguidesExists && showGameInfo && React.createElement(TopBarTabs, {
    setActiveTab: setActiveTab,
    spelguides: spelguides
  }))));
});

 })(window);